export default "__VITE_ASSET__DMmae4Nt__"